import { Product } from "../models/product";

var Products = Backbone.Collection.extend({
    'model': Product,
    'sort_key' : 'order',
    'sort_order' : 1,
    'comparator': function( a, b ){
        var item1 = this.sort_order > 0 ? a : b;
        var item2 = this.sort_order > 0 ? b : a;
        var val1 = item1.get(this.sort_key);
        var val2 = item2.get(this.sort_key);

        if ( this.sort_key == 'name' ) {
            return val1.localeCompare(val2);
        }

        if ( this.sort_key == 'price' ) {
            var price1 = val1.substr(1).replace(/\,/g,''); // remove $ and ,
            if ( price1.length == 0 ) {
                price1 = '0';
            }
            var price2 = val2.substr(1).replace(/\,/g,''); // remove $ and ,
            if ( price2.length == 0 ) {
                price2 = '0';
            }
            val1 = parseInt( price1 );
            val2 = parseInt( price2 );
        } 
        var sortValue = val1 == val2 ? 0 : val1 - val2;
        if ( sortValue == 0 ) {
            var name1 = a.get('name');
            var name2 = b.get('name');
            return name1.localeCompare(name2);
        } else {
            return sortValue;
        }
    } 
});

export {Products};